<!-- Modals -->
<app-deprecated-modal-form
    #announcementModal
    [form]="announcementForm"
    (save)="sendAnnouncement(announcementForm.announcement, announcementForm)"
    headerText="{{ 'dashboard.sendCompanyAnnouncement' | translate }}"
    label="{{ 'dashboard.createAnnouncement' | translate }}"
>
    <app-form-announcement #announcementForm></app-form-announcement>
</app-deprecated-modal-form>

<div class="page-container no-scroll inner-padding">
    <div class="flex">
        <app-avatar [employee]="auth.employee" size="inline" class="margin-right-2"></app-avatar>
        <app-header
            title="{{ getTimeGreeting() | translate: { name: getFirstName() } }}"
            subtitle="{{ 'dashboard.hereIsWhatHAppeningToday' | translate }}"
            class="header"
        >
            <!-- we show at most one quick action button -->
            <!-- what that button is depends on the role -->
            <div class="buttons align-center">
                <!-- announcement button -->
                <!-- shown if the user can send announcements -->
                <ui-button *ngIf="canSendAnnouncement" type="primary" (click)="createAnnouncement(announcementModal)">{{
                    'dashboard.createAnnouncement' | translate
                }}</ui-button>

                <!-- time off request button -->
                <!-- shown if the user cannot send announcements but can book time off -->
                <ui-button
                    *ngIf="!canSendAnnouncement && isEmployee && canBookTimeOffFromDashboard"
                    type="primary"
                    [routerLink]="['/time-off', 'v3', 'requests', 'create']"
                    >{{ 'dashboard.requestTimeOff' | translate }}
                </ui-button>
            </div>
        </app-header>
    </div>
    <div class="container">
        <!-- notifications -->
        <app-inbox-viewer #inboxViewer></app-inbox-viewer>

        <!-- right column -->
        <div class="right-column">
            <time-tracking-dashboard-widget
                *ngIf="showTimeTrackingWidget"
                [minutesToday]="timeTrackingMinutes.today"
                [minutesYesterday]="timeTrackingMinutes.yesterday"
            ></time-tracking-dashboard-widget>

            <app-time-clock-widget
                *ngIf="showTimeClockWidget"
                [minutesToday]="timeTrackingMinutes.today"
                [timeClockEntries]="timeClockEntries"
                (onClockOut)="loadTimeClockData()"
            ></app-time-clock-widget>

            <app-upcoming-events-viewer></app-upcoming-events-viewer>
        </div>
    </div>
</div>
